import {updateUrlOnDateSwitchChange, updateUrlParams} from "../../../utils";
import {useSearchParams} from "react-router";
import {CustomerFilterAutoComplete, FieldDateSwitch2, FieldDateSwitchValue, FieldInput} from "../../ui";
import {useEffect, useState} from "react";
import {pageQueryStore} from "../../../store";
import {FieldMultiSelect} from "@kroschke/react-ui";
import {ShipmentPackageStatusDto, ShipmentProcessTypeDto, ShipmentTypeDto} from "../../../api/fms";
import {displayShipmentPackageStatus, displayShipmentProcessType, displayShipmentType} from "../../../api";
import {fmsCustomerStore} from "../../../store/fms/FmsCustomerStore";

const shipmentTypeDropDownOptions = Object.keys(ShipmentTypeDto).map(e => ({
    value: e,
    label: displayShipmentType(e as ShipmentTypeDto)
}))

const processDropDownOptions = Object.keys(ShipmentProcessTypeDto).map(e => ({
    value: e,
    label: displayShipmentProcessType(e as ShipmentProcessTypeDto)
}))

const statusDropDownOptions = Object.keys(ShipmentPackageStatusDto).map(e => ({
    value: e,
    label: displayShipmentPackageStatus(e as ShipmentPackageStatusDto)
}))

function FmsShipmentPackageFilterbar() {
    const [searchParams, setSearchParams] = useSearchParams()

    const shipment = (searchParams.getAll('shipmentType') || [])
    const process = (searchParams.getAll('process') || [])
    const status = (searchParams.getAll('status') || [])
    const compartment = (searchParams.get('compartment') || '')

    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined
    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)
    const [shipmentType, setShipmentType] = useState(shipment)
    const [processType, setProcessType] = useState(process)
    const [pacStatus, setPacStatus] = useState(status)
    const [pacCompartment, setPacCompartment] = useState(compartment)


    useEffect(() => {
        const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
        const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined

        setFrom(fromS ? {
            absolute: searchParams.get('fromAbsolute') || undefined,
            relative: searchParams.get('fromRelative') || undefined,
        } : undefined)
        setTo(toS ? {
            absolute: searchParams.get('toAbsolute') || undefined,
            relative: searchParams.get('toRelative') || undefined,
        } : undefined)
    }, [
        searchParams,
        setFrom,
        setTo
    ])

    const hasFilter =
        Boolean(fromS)
        || Boolean(toS)
        || Boolean(shipmentType.length)
        || Boolean(processType.length)
        || Boolean(status)
        || Boolean(compartment)

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>
        <div style={{
            minWidth: '2em',
            maxWidth: '12em',
            marginRight: '1em'
        }}>
            <CustomerFilterAutoComplete
                items={fmsCustomerStore.items}
                search={fmsCustomerStore.search}
                param={'customerId'}/>
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Von"}
                value={from}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                    setFrom(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Bis"}
                value={to}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                    setTo(v)
                }}
            />
        </div>
        <div style={{
        minWidth: '12em',
        maxWidth: '20em',
        marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Versandart"}
                options={shipmentTypeDropDownOptions}
                value={shipmentType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'shipmentType', value}], setSearchParams, searchParams})
                    setShipmentType(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Prozess"}
                options={processDropDownOptions}
                value={processType}
                onChange={value => {
                    updateUrlParams({val: [{param: 'process', value}], setSearchParams, searchParams})
                    setProcessType(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '12em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Status"}
                options={statusDropDownOptions}
                value={pacStatus}
                onChange={value => {
                    updateUrlParams({val: [{param: 'status', value}], setSearchParams, searchParams})
                    setPacStatus(value)
                }}
            />
        </div>
        <div style={{
            minWidth: '11em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldInput
                label={"Fach"}
                value={pacCompartment}
                onChange={value => {
                    updateUrlParams({val: [{param: 'compartment', value: [value]}], setSearchParams, searchParams})
                    setPacCompartment(value)
                }}
            />
        </div>
        {<div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    setFrom(undefined)
                    setTo(undefined)
                    setShipmentType([])
                    setProcessType([])
                    setPacStatus([])
                    setPacCompartment('')
                    Array.from(searchParams.keys()).forEach(key => {
                        searchParams.delete(key)
                    })
                    setSearchParams(searchParams)
                    pageQueryStore.clear('fms-packages')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>}
    </div>
}
export {
    FmsShipmentPackageFilterbar
}
